// export class AdminUser{
//     id!:string;
//     userName!:string;
//     phoneNumber!:string;
//     email!:string;
//     dateOfBirth!:string;
//     roleName!:string;
//     status!:string;
// }
// export interface AdminUser {
//     Id: string;
//     UserName: string;
//     PhoneNumber: string;
//     Email: string;
//     DateOfBirth: string;
//     RoleName: string;
//     Status: string;
//   }
export class AdminUser {
  Id!: string;
  UserName!: string;
  PhoneNumber!: string;
  Email!: string;
  DateOfBirth!: string;
  CreatedDate!: string;
  RoleName!: string;
  RoleId!: string;
  Status!: string;
  RegionIds!:string[];
  Regions!:string[];
  BranchId!: string;
  TerminalId!: string;
}

export class LoginAdminUser {
  Email!: string;
  Password!: string;
  GrantType!: string;
  PhoneNumber!: string;
}

export class VerifyOtp {
  Email!: string;
  AuthenticatorCode!: string;
  Provider!: string;
}

export class Permission {
  Id: number = 0;
  ParentMenu: string = '';
  PermissionValue: string = '';
  IsChildMenu: boolean = false;
  IsChecked: boolean = false;
} 